import {AppButtonIcon} from "@components"
import {REAL_TIME_ROUTES} from "@constants"

import {Box, Divider, Typography} from "@mui/material"
import React from "react"
import { dsColorNew } from "@palette"


export default function priceColumn() {

	return {
		name: "price",
		label: "Price",
		options: {
			filter: false,
			customBodyRowRenderLite: ({ main, competitor }, { idSearch }) => <Box>
				<Box sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
					<Typography sx={{ fontWeight: "bold" }}>{main}</Typography>
					<AppButtonIcon
						sx={{
							width: 28,
							height: 28,
							border: "none",
							color: dsColorNew.appBlue,
							mt: 0.5,
							mx: 0.5,
							fontSize: 28,
							"&:hover": {
								border: "none",
							},
						}}
						icon="magnifying-glass-chart"
						onClick={e => {
							window.open(`${REAL_TIME_ROUTES.SEARCHES_PATH}?idSearch=${idSearch.main}`)
							if (e.ctrlKey) e.preventDefault()
						}}
						tooltip="View in real time searches"
					/>
				</Box>
				<Divider sx={{ my: 1, width: "80%", borderColor: dsColorNew.grayBorder }}/>
				<Box sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
					<Typography>{competitor}</Typography>
					<AppButtonIcon
						sx={{
							width: 28,
							height: 28,
							border: "none",
							color: dsColorNew.appBlue,
							mt: 0.5,
							mx: 0.5,
							fontSize: 28,
							"&:hover": {
								border: "none",
							},
						}}
						icon="magnifying-glass-chart"
						onClick={e => {
							window.open(`${REAL_TIME_ROUTES.SEARCHES_PATH}?idSearch=${idSearch.competitor}`)
							if (e.ctrlKey) e.preventDefault()
						}}
						tooltip="View in real time searches"
					/>
				</Box>
			</Box>,
		},
	}
}